const imageMap = {
    'Steering Wheel': 'steering-wheel-regular',
    'Yoke Steering': 'steering-wheel-yoke',
}

const simpleNames = ['steering-wheel', 'yoke-steering']

export const onlyTextRegex = /[^a-z0-9]/g

function createImageKey(description) {
    return description.toLowerCase().replace(onlyTextRegex, '')
}

const normalizedImageMap = Object.keys(imageMap).reduce(
    (target, imageKey) => ({
        ...target,
        [createImageKey(imageKey)]: imageMap[imageKey],
    }),
    {}
)

export function getSteeringWheelImage(description) {
    const imageKey = createImageKey(description)
    let color = normalizedImageMap.hasOwnProperty(imageKey) ? normalizedImageMap[imageKey] : undefined

    // if exact match was not found, get the color by testing if a simple color name is in the string
    if (!color) {
        const simpleName = simpleNames.find(simpleName =>
            simpleName.split('-').every(simpleNamePart => simpleNamePart.indexOf(imageKey) > -1)
        )
        if (simpleName) {
            color = `steering-wheel-${simpleName}`
        }
    }
    return color ? `/assets/images/swatches/${color}.png` : null
}
